<lazy-echart
    class="chart"
    [options]="histogramOptions"
    [class.chart--fixed-height]="hasFixedHeight"
    (chartClick)="chartClicked($event)">
</lazy-echart>
